import { render, staticRenderFns } from "./inscription-page.vue?vue&type=template&id=60ae195e&"
import script from "./inscription-page.component.ts?vue&type=script&lang=ts&"
export * from "./inscription-page.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kevinmathieu/crr-sl-fr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60ae195e')) {
      api.createRecord('60ae195e', component.options)
    } else {
      api.reload('60ae195e', component.options)
    }
    module.hot.accept("./inscription-page.vue?vue&type=template&id=60ae195e&", function () {
      api.rerender('60ae195e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/fo/pages/inscription-page/inscription-page.vue"
export default component.exports